import { applyPageMetadata } from "@/lib/page-metadata";
import { createFileRoute } from "@tanstack/react-router";
import { BlogListingPage } from "@/components/site/BlogListingPage";
import { breadcrumbSchema, jsonLdScript, organizationSchema } from "@/lib/seo";

export const Route = createFileRoute("/blog/")({
  head: () => applyPageMetadata("/blog", {
    meta: [
      { title: "Law Firm SEO Blog | Guides, Strategy & Tactics" },
      {
        name: "description",
        content: "In-depth guides on law firm SEO strategy, local SEO, technical SEO, content, and link building for attorneys.",
      },
      { name: "robots", content: "index, follow" },
      { property: "og:title", content: "Law Firm SEO Blog | PageOne Lawyers" },
      {
        property: "og:description",
        content: "In-depth law firm SEO guides.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://pageonelawyers.com/blog" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://pageonelawyers.com/blog" }],
    scripts: [
      jsonLdScript(organizationSchema()),
      jsonLdScript(
        breadcrumbSchema([
          { label: "Home", path: "/" },
          { label: "Blog", path: "/blog" },
        ]),
      ),
    ],
  }),
  component: () => <BlogListingPage currentPage={1} />,
});